import { render, staticRenderFns } from "./Seizure.vue?vue&type=template&id=73b74f1d&"
import script from "./Seizure.vue?vue&type=script&lang=js&"
export * from "./Seizure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports